import { useQuery } from "@tanstack/react-query"

import { useAo } from "../ao/ao"
import { getPoolInfo } from "../ao/pool"

function usePoolDetails(poolId: string) {
  const ao = useAo()

  return useQuery({
    queryKey: ["poolInfo", poolId],
    queryFn: async () => {
      return await getPoolInfo(poolId, ao)
    },
    staleTime: 1000 * 3600,
    enabled: !!poolId,
  })
}

export default usePoolDetails
